
import { getLanguage } from "@/plugins/i18n"

export default {
  name: "CouponItem",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    invalid: {
      type: Boolean,
      default: false
    },
    operable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      statusCodeMap: {
        4: "couponUsed",
        8: "couponExpired",
        16: "couponVoided"
      },
      lang: ""
    }
  },
  computed: {
    isMpj() {
      return (this.item.limitApp || "").split(",").includes("2")
    },
    isColdStorage() {
      return (this.item.limitApp || "").split(",").includes("1")
    },
    isYuu() {
      return (this.item.limitApp || "").split(",").includes("3")
    },
    isWellcome() {
      return (this.item.limitApp || "").split(",").includes("4")
    }
  },
  mounted() {
    this.lang = getLanguage()
  },
  methods: {
    formatMainTypeLabel(value = "") {
      if (value === "Market Place Plus Offer") return "yuu Online Shop Offer"
      return value
    },
    formatName(value = "") {
      if (value === "E-Gift Voucher" || value === "電子禮券") return this.$t("coupon.EGiftVoucher")
      if (value === "E-Coupon" || value === "電子現金券") return this.$t("coupon.ECoupon")
      return value
    },
    toggleArrowDirection(item) {
      item.isExpand = !item.isExpand
      this.$emit("arrowChange", item)
    }
  }
}
